import { makeStyles, shorthands } from '@fluentui/react-components';

export const useHomePageStyle = makeStyles({
  homePage: {
    display: 'flex',
    ...shorthands.margin('32px', '36px'),
    flexDirection: 'column',
    ...shorthands.gap('10px'),
  },
});
